import { SubentityStateModel } from 'app/projects/subentity/src/lib/models/subentity.state-model';
import { Module } from './module.model';

export class ModulesStateModel extends SubentityStateModel {
    targetModulesList: Module[];
}
